import {IPut} from "../interfaces/requests";
import {api} from "../../../helpers";

export const axiosPut = <Model>({url, data}: IPut<Model>) => {
  return api.put(url, data);
};
